export var TermsAndConditionsType;
(function (TermsAndConditionsType) {
    TermsAndConditionsType["BORROWER"] = "borrower_tc";
    TermsAndConditionsType["INVESTOR"] = "investor_tc";
})(TermsAndConditionsType || (TermsAndConditionsType = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["LoanSpecialConditions"] = "LoanSpecialConditions";
    DocumentType["LoanSchedule"] = "LoanSchedule";
    DocumentType["InvestmentSpecialConditions"] = "InvestmentSpecialConditions";
    DocumentType["InvestmentLoanSchedule"] = "InvestmentLoanSchedule";
})(DocumentType || (DocumentType = {}));
